import { useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useGetApi } from "src/hooks";

import UserSelect, {
  type UserSelectProps,
} from "../_Selects/UserSelect/UserSelect";

interface Props extends UserSelectProps {
  hideSig?: boolean;
}

const SigboxInput = (props: Props) => {
  const { control, setValue } = useFormContext();
  const user = useWatch({ control, name: props.id, defaultValue: props.value });

  const { refetch: fetchSignature } = useGetApi({
    request: "get-user-sig",
    fetchOnInit: false,
  });

  const handleSignature = useCallback(
    async (userid: string) => {
      const data = await fetchSignature({ params: { userid } });
      if (data?.data?.signature) {
        setValue(`${props.id}.signature`, data.data.signature);
      }
    },
    [fetchSignature, props.id, setValue],
  );
  return (
    <>
      <UserSelect {...props} additionalOnChange={handleSignature} />
      {!props.hideSig && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          {user?.signature && (
            <img
              id="signature-img"
              height={"80px"}
              style={{
                objectFit: "contain",
                maxWidth: "100%",
                marginTop: "10px",
              }}
              src={user.signature}></img>
          )}
        </div>
      )}
    </>
  );
};

export default SigboxInput;
